import React, {Component} from 'react';
import styles from "../../../InfoCliniche/InfoCliniche.module.css";
import Calendar from "../../../../../../components/calendar/Calendar";
import RadioButton from "../../../../../../components/radiobutton/RadioButton";
import Input from "../../../../../../components/textbox/Input";
import {withTranslation} from "react-i18next";
import Autocomplete from '../../../../../../components/autocomplete/Autocomplete';
import OggettiUtili from "../../../../../../utils/OggettiUtili.json";
import Utils from "../../../../../../utils/Utils"
import Select from "../../../../../../components/select/Select";
import ProfessioniEpatiteE from "../../../../../../utils/ProfessioniEpatiteE.json"


class SezioneDue extends Component {

    state = {

        sezioneDue: {
            dataIntervista: "",
            nomeIniziale: "",
            cognomeIniziale: "",
            comuneDomicilio: "",
            cittadinanza: "",
            eta: "",
            mesi: "",
            sesso: "",
            professione: "",
            titoloStudio: "",
            anniItalia: "",
            corretto: []
        },
        comuni: JSON.parse(sessionStorage.getItem("comuni")),
        nazioni: JSON.parse(sessionStorage.getItem("nazioni")),
        nazioniPerCodice: JSON.parse(sessionStorage.getItem("nazioniPerCodice")),
        comuniPerCodice: JSON.parse(sessionStorage.getItem("comuniPerCodice")),
        professioni: ProfessioniEpatiteE,
        professioniPerCodice: Utils.arrayToMap(ProfessioniEpatiteE, "codice"),
        mappingProfessioni: OggettiUtili.mappingProfessioniEpatiteE,
        controlloAutocomplete: {
            professione: true,
            titoloStudio: true
        }

    }

    constructor(props) {
        super(props);
        this.riceviValoreInput = this.riceviValoreInput.bind(this);
        this.riceviValoreRadioButton = this.riceviValoreRadioButton.bind(this);
        this.controllaDati = this.controllaDati.bind(this);
        this.createJsonBackend = this.createJsonBackend.bind(this)
        this.validate = this.validate.bind(this)
    }

    componentDidMount() {
        let sezioneDue = this.state.sezioneDue
        let controlloAutocomplete = this.state.controlloAutocomplete
        if (this.props.segnalazioneCopia.schedaSpeciale && this.props.segnalazioneCopia.schedaSpeciale.sezioneDue) {
            let propsSezioneDue = JSON.parse(JSON.stringify(this.props.segnalazioneCopia.schedaSpeciale.sezioneDue));
            sezioneDue.dataIntervista = propsSezioneDue.dataIntervista ? propsSezioneDue.dataIntervista : ""
            sezioneDue.nomeIniziale = propsSezioneDue.nomeIniziale ? propsSezioneDue.nomeIniziale : (this.props.datiPaziente && this.props.datiPaziente.nomePaziente ? this.props.datiPaziente.nomePaziente.charAt(0) : " ")
            sezioneDue.cognomeIniziale = propsSezioneDue.cognomeIniziale ? propsSezioneDue.cognomeIniziale : (this.props.datiPaziente && this.props.datiPaziente.cognomePaziente ? this.props.datiPaziente.cognomePaziente.charAt(0) : " ")
            sezioneDue.comuneDomicilio = propsSezioneDue.comuneDomicilio ? this.state.comuniPerCodice[propsSezioneDue.comuneDomicilio] : ""
            sezioneDue.cittadinanza = propsSezioneDue.cittadinanza ? this.state.nazioniPerCodice[propsSezioneDue.cittadinanza] : ""
            sezioneDue.eta = propsSezioneDue.eta ? propsSezioneDue.eta : "0"
            sezioneDue.mesi = propsSezioneDue.mesi ? propsSezioneDue.mesi : "0"
            sezioneDue.sesso = propsSezioneDue.sesso ? propsSezioneDue.sesso : ""
            sezioneDue.professione = propsSezioneDue.professione && this.state.professioniPerCodice[propsSezioneDue.professione] ? this.state.professioniPerCodice[propsSezioneDue.professione] : propsSezioneDue.professione ? propsSezioneDue.professione : ""
            controlloAutocomplete.professione = propsSezioneDue.professione && propsSezioneDue.professione.codice ? true : false
            sezioneDue.titoloStudio = propsSezioneDue.titoloStudio ? propsSezioneDue.titoloStudio : ""
            controlloAutocomplete.titoloStudio = propsSezioneDue.titoloStudio && Utils.arrayToMap(OggettiUtili.titoloStudio, "codice")[sezioneDue.titoloStudio] ? true : false
            sezioneDue.anniItalia = propsSezioneDue.anniItalia ? propsSezioneDue.anniItalia : ""
        } else {
            sezioneDue.professione = this.props.datiPaziente && this.props.datiPaziente.professione ? this.state.mappingProfessioni[this.props.datiPaziente.professione] : ""
            sezioneDue.nomeIniziale = (this.props.datiPaziente ? this.props.datiPaziente.nomePaziente.charAt(0) : "")
            sezioneDue.cognomeIniziale = (this.props.datiPaziente ? this.props.datiPaziente.cognomePaziente.charAt(0) : "")
            sezioneDue.eta = (this.props.datiPaziente ? this.props.datiPaziente.eta : "")
            sezioneDue.mesi = (this.props.datiPaziente ? this.props.datiPaziente.mesi : "")
            sezioneDue.sesso = (this.props.datiPaziente ? this.props.datiPaziente.sesso : "")
            sezioneDue.comuneDomicilio = this.props.datiPaziente && this.props.datiPaziente.comuneDomicilio ? this.props.datiPaziente.comuneDomicilio : ""
            sezioneDue.cittadinanza = this.props.datiPaziente && this.props.datiPaziente.cittadinanza ? this.state.nazioniPerCodice[this.props.datiPaziente.cittadinanza.codice] : ""
        }
        this.setState({sezioneDue: sezioneDue, controlloAutocomplete: controlloAutocomplete});

        this.controllaDati();

        this.props.setSezioneDue(this.state.sezioneDue)
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        this.controllaDati();
        if (prevState !== this.state) {
            let res = this.createJsonBackend()
            this.props.setSezioneDue(this.state.sezioneDue, this.validate(), res)
        }
    }


    createJsonBackend() {
        let dati = JSON.parse(JSON.stringify(this.state.sezioneDue))
        let sezioneBackend = Utils.removeEmptyValueFromObject(dati)
        if (dati.comuneDomicilio && dati.comuneDomicilio.codice) {
            dati.comuneDomicilio = dati.comuneDomicilio.codice
        }
        if (dati.cittadinanza && dati.cittadinanza.codice) {
            dati.cittadinanza = dati.cittadinanza.codice
        }
        if (dati.professione && dati.professione.codice) {
            dati.professione = dati.professione.codice
        }
        return Utils.removeFieldFromObject(sezioneBackend, "corretto")
    }

    controllaDati() {

        let dati = this.state.sezioneDue
        dati.corretto = []

        if (!dati.eta && dati.eta !== 0) dati.corretto[0] = "Campo \"Eta\" mancante";
        if (!dati.cognomeIniziale && !this.props.datiPaziente.soggettoAnonimizzato) dati.corretto[1] = "Campo \"Cognome (Iniziale)\" mancante";
        if (!dati.nomeIniziale && !this.props.datiPaziente.soggettoAnonimizzato) dati.corretto[2] = "Campo \"Nome (Iniziale)\" mancante";
        if (dati.cittadinanza && dati.cittadinanza.codice && dati.cittadinanza.codice !== "100" && !dati.anniItalia) dati.corretto[3] = "Campo \"Da quanti anni vive in Italia?\" mancante";
        if (dati.dataIntervista && Utils.isDateInValid(Utils.transformDateForBackend(dati.dataIntervista), "-")) dati.corretto[4] = "Campo \"Data Intervista\" errato";
        if (!dati.mesi && dati.mesi !== 0) dati.corretto[5] = "Campo \"Eta mesi\" mancante";

    }

    validate() {

        if (this.state.sezioneDue.dataIntervista) {
            let validatedataIntervista = Utils.checkDateInterval(this.state.sezioneDue.dataIntervista, "31/12/1899");
            let validatedataIntervistaOdierna = Utils.checkDateInterval(this.state.sezioneDue.dataIntervista, Utils.transformTimeStampForFrontend(Utils.getTodayDateTimestamp()));

            if (validatedataIntervista) {
                return "Messages.DataIntervista"
            } else if (!validatedataIntervistaOdierna) {
                return "Messages.DataIntervistaOdierna"
            }
        }

        return ""

    }

    riceviValoreRadioButton(event, field) {
        let sezioneDue = this.state.sezioneDue
        sezioneDue[field] = event
        this.setState({sezioneDue: sezioneDue})
    }

    riceviValoreInput(field, event) {

        let controlloAutocomplete = this.state.controlloAutocomplete
        let sezioneDue = this.state.sezioneDue
        if (field.currentTarget) {
            sezioneDue[field.currentTarget.id] = field.currentTarget.value
        } else {
            if (field.includes("titoloStudio") && !event.target.value) {
                controlloAutocomplete.titoloStudio = true
            } else if (field.includes("professione") && !event.target.value) {
                controlloAutocomplete.professione = true
            }
            sezioneDue[field] = event.target.value
        }
        if ((sezioneDue.cittadinanza && !sezioneDue.cittadinanza.codice) || (sezioneDue.cittadinanza && sezioneDue.cittadinanza.codice && sezioneDue.cittadinanza.codice === "100")) {
            sezioneDue.anniItalia = ""
        }
        this.setState({sezioneDue: sezioneDue, controlloAutocomplete: controlloAutocomplete})
    }

    render() {

        const {t} = this.props;

        const sezioneDue = (
            <div style={{marginTop: "10px"}}>
                <div>
                    <h6>Sezione 2</h6>
                    <hr className={styles.hr}/>
                </div>
                <div className={"container"}>
                    <div className="row">
                        <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello3' : ''}`}>
                            <p className={styles.labelHeader} style={{color: "#1b7ea9", marginTop: "10px"}}>
                                {t("SchedaEpatite.dataIntervista")}
                            </p>
                            <Calendar
                                id={"dataIntervista"}
                                field={"dataIntervista"}
                                value={this.state.sezioneDue.dataIntervista}
                                onChange={this.riceviValoreInput}
                                errorMessage={Utils.replaceContentString(t("Messages.ERR_01_01_0B_0A"), "<nome campo>",
                                    "Data")}
                                error={(this.state.sezioneDue.dataIntervista === "" ||
                                    this.state.sezioneDue.dataIntervista == null) ? false :
                                    Utils.isDateInValid(Utils.transformDateForBackend(this.state.sezioneDue.dataIntervista), "-")}>
                            </Calendar>

                        </div>
                        <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello2' : ''}`}>
                            <p className={styles.labelHeader} style={{color: "#1b7ea9", marginTop: "10px"}}>
                                {t("SchedaEpatite.cognomeIniziale")}
                                {!this.props.datiPaziente.soggettoAnonimizzato ?
                                    <span className={styles.mandatoryColor}>*</span> : ""}
                            </p>
                            <Input
                                id={"cognomeIniziale"}
                                maxLength={"1"}
                                onChange={this.riceviValoreInput}
                                field={"cognomeIniziale"}
                                errorMessage={"sezione non valido"}
                                value={this.state.sezioneDue.cognomeIniziale}
                                placeholder={t("SchedaEpatite.cognomeIniziale")}
                            >
                            </Input>
                        </div>
                        <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello1' : ''}`}>
                            <p className={styles.labelHeader} style={{color: "#1b7ea9", marginTop: "10px"}}>
                                {t("SchedaEpatite.nomeIniziale")}
                                {!this.props.datiPaziente.soggettoAnonimizzato ?
                                    <span className={styles.mandatoryColor}>*</span> : ""}
                            </p>
                            <Input
                                id={"nomeIniziale"}
                                onChange={this.riceviValoreInput}
                                maxLength={"1"}
                                field={"nomeIniziale"}
                                errorMessage={"sezione non valido"}
                                value={this.state.sezioneDue.nomeIniziale}
                                placeholder={t("SchedaEpatite.nomeIniziale")}
                            >
                            </Input>
                        </div>
                    </div>
                    <div className="row">
                        <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello3' : ''}`}>
                            <div className={styles.fieldContainer}>
                                <p className={styles.labelHeader} style={{color: "#1b7ea9", marginTop: "10px"}}>
                                    {t("SchedaEpatite.comuneDomicilio")}
                                </p>
                                <Autocomplete
                                    id={"comuneDomicilio"}
                                    keyField={"codice"}
                                    descriptionField={"descrizione"}
                                    suggestionField={"descrizione"}
                                    onChange={this.riceviValoreInput}
                                    value={this.state.sezioneDue.comuneDomicilio}
                                    //onChange={this.riceviValore}
                                    field={"comuneDomicilio"}
                                    placeholder={t("SchedaEpatite.comuneDomicilio")}
                                    suggestions={this.state.comuni}
                                >

                                </Autocomplete>
                            </div>

                        </div>
                        <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello2' : ''}`}>
                            <div className={styles.fieldContainer}>

                                <p className={styles.labelHeader} style={{color: "#1b7ea9", marginTop: "10px"}}>
                                    {t("SchedaEpatite.cittadinanza")}
                                </p>

                                <Autocomplete id={"cittadinanza"}
                                              keyField={"codice"}
                                              descriptionField={"descrizione"}
                                              suggestionField={"descrizione"}
                                              onChange={this.riceviValoreInput}
                                              field={"cittadinanza"}
                                              placeholder={t("SchedaEpatite.cittadinanza")}
                                              suggestions={this.state.nazioni}
                                              value={this.state.sezioneDue.cittadinanza}
                                >
                                </Autocomplete>
                            </div>
                        </div>

                        <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello1' : ''}`}>
                            <p className={styles.labelHeader} style={{color: "#1b7ea9", marginTop: "10px"}}>
                                {t("SchedaEpatite.daQuantiAnni")}
                                {this.state.sezioneDue.cittadinanza && this.state.sezioneDue.cittadinanza.codice && this.state.sezioneDue.cittadinanza.codice !== "100" ?
                                    <span className={styles.mandatoryColor}>*</span> : <span/>}
                            </p>
                            <Input
                                id={"anniItalia"}
                                onChange={this.riceviValoreInput}
                                field={"anniItalia"}
                                min="0"
                                type={"number"}
                                disabled={(this.state.sezioneDue.cittadinanza && !this.state.sezioneDue.cittadinanza.codice) || (this.state.sezioneDue.cittadinanza && this.state.sezioneDue.cittadinanza.codice && this.state.sezioneDue.cittadinanza.codice === "100")}
                                errorMessage={"sezione non valido"}
                                value={this.state.sezioneDue.anniItalia}
                                placeholder={"Anni"}
                            >
                            </Input>
                        </div>
                    </div>
                    <div className="row">
                        <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello3' : ''}`}>
                            <p className={styles.labelHeader} style={{color: "#1b7ea9", marginTop: "10px"}}>
                                {t("SchedaEpatite.eta")}
                                <span className={styles.mandatoryColor}>*</span>
                            </p>
                            <Input
                                id={"eta"}
                                onChange={this.riceviValoreInput}
                                field={"eta"}
                                disabled={true}
                                errorMessage={"sezione non valido"}
                                value={this.state.sezioneDue.eta}
                                type={"number"}
                                min={"0"}
                                placeholder={t("SchedaEpatite.eta")}
                            >
                            </Input>
                        </div>
                        <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello2' : ''}`}>
                            <p className={styles.labelHeader} style={{color: "#1b7ea9", marginTop: "10px"}}>
                                {t("SchedaEpatite.mesi")}
                                <span className={styles.mandatoryColor}>*</span>
                            </p>
                            <Input
                                id={"mesi"}
                                onChange={this.riceviValoreInput}
                                field={"mesi"}
                                disabled={true}
                                errorMessage={"sezione non valido"}
                                value={this.state.sezioneDue.mesi}
                                type={"number"}
                                min={"0"}
                                placeholder={t("SchedaEpatite.mesi")}
                            >
                            </Input>
                        </div>
                        <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello1' : ''}`}>
                            <p className={styles.labelHeader} style={{color: "#1b7ea9", marginTop: "10px"}}>
                                {t("SchedaEpatite.sesso")}
                            </p>
                            <div className="row">
                                <RadioButton id={"sessoM"}
                                             name={"sesso"} label={"M"}
                                             value={"1"}
                                             onClick={() => this.riceviValoreRadioButton("M", "sesso")}
                                             checked={this.state.sezioneDue.sesso === "M"}>
                                </RadioButton>
                                <RadioButton id={"sessoF"}
                                             name={"sesso"} label={"F"}
                                             value={"0"}
                                             onClick={() => this.riceviValoreRadioButton("F", "sesso")}
                                             checked={this.state.sezioneDue.sesso === "F"}>
                                </RadioButton>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello2' : ''}`}>
                            <p className={styles.labelHeader} style={{color: "#1b7ea9", marginTop: "10px"}}>
                                {t("SchedaEpatite.attività")}
                            </p>
                            {(this.state.sezioneDue.professione && this.state.sezioneDue.professione.codice) || !this.state.sezioneDue.professione || this.state.controlloAutocomplete.professione ?

                                <Autocomplete
                                    id={"professione"}
                                    onChange={this.riceviValoreInput}
                                    field={"professione"}
                                    value={this.state.sezioneDue.professione}
                                    keyField={"codice"}
                                    descriptionField={"descrizione"}
                                    suggestionField={"descrizione"}
                                    placeholder={t("SchedaEpatite.attività")}
                                    suggestions={this.state.professioni}
                                >
                                </Autocomplete>
                                :
                                <Input
                                    id={"professione"}
                                    onChange={this.riceviValoreInput}
                                    field={"professione"}
                                    value={this.state.sezioneDue.professione}
                                    placeholder={t("SchedaEpatite.attività")}
                                >
                                </Input>
                            }

                        </div>
                        <div className={`col-lg-6 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello1' : ''}`}>
                            <p className={styles.labelHeader} style={{color: "#1b7ea9", marginTop: "10px"}}>
                                {t("SchedaEpatite.titoloStudio")}
                            </p>
                            {(this.state.sezioneDue.titoloStudio && Utils.arrayToMap(OggettiUtili.titoloStudio, "codice")[this.state.sezioneDue.titoloStudio]) || !this.state.sezioneDue.titoloStudio || this.state.controlloAutocomplete.titoloStudio ?

                                <Select
                                    id={"titoloStudio"}
                                    value={this.state.sezioneDue.titoloStudio}
                                    onChange={this.riceviValoreInput}
                                    functionMap={OggettiUtili.titoloStudio.map((oggetto) => {
                                        return (<option value={oggetto.codice}>{oggetto.descrizione}</option>)
                                    })}>

                                </Select>
                                :
                                <Input
                                    id={"titoloStudio"}
                                    onChange={this.riceviValoreInput}
                                    field={"titoloStudio"}
                                    value={this.state.sezioneDue.titoloStudio}
                                    placeholder={t("SchedaEpatite.titoloStudio")}
                                >
                                </Input>
                            }

                        </div>

                    </div>
                </div>
            </div>
        );


        return <div>

            {sezioneDue}
        </div>
    }


}

export default withTranslation('common')(SezioneDue)
